import { getClientProps } from "../utils";

const { clientName } = getClientProps();
const theme = require(`./${clientName}.js`);

export default theme.default;
